import { ColorScheme } from "features/CenterContent/RoleContent/EventHandling/components/InfraEventCard/types";
import { Semantics } from "shared/components/drops/DropsBadge";
import { useThemeSemantic } from "shared/theme/themeSemantic";

export const getSemantics = (
  changed: boolean,
  notifying: boolean,
): Semantics => {
  if (changed) return "warning";
  if (notifying) return "alarm";
  return "neutral";
};

export const useColorScheme = (
  changed: boolean,
  notifying: boolean,
  disabled: boolean,
): ColorScheme => {
  const semantics = getSemantics(changed, notifying);
  const theme = useThemeSemantic(semantics);

  if (disabled) {
    return {
      backgroundColor: theme.colorBackgroundSecondary,
      backgroundColorHover: theme.colorBackgroundSecondary,
      borderColor: theme.colorOutlineSecondary,
      accentColor: theme.colorTextDisabled,
      textColorMain: theme.colorTextDisabled,
      textColorSecondary: theme.colorTextDisabled,
    };
  }
  return {
    backgroundColor: theme.colorSemanticFillPulse,
    backgroundColorHover: theme.colorSemanticFill,
    borderColor: theme.colorSemanticOutline,
    accentColor: theme.colorSemantic,
    textColorMain: theme.colorSemanticTextMain,
    textColorSecondary: theme.colorSemanticTextSecondary,
  };
};
